// extracted by mini-css-extract-plugin
export default {"card":"CommonAndGlobalSettings_card__t6PQS","title":"CommonAndGlobalSettings_title__G4mJI"};